import React from "react";

export default function OrderRequiredIcon(props) {
  return (
    <svg width={23} height={23} viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M19.1667 14.8542C17.9688 14.8542 16.8188 14.6625 15.7454 14.3079C15.6496 14.2792 15.5442 14.26 15.4483 14.26C15.1992 14.26 14.9596 14.3558 14.7679 14.5379L12.6596 16.6462C9.9475 15.2662 7.72417 13.0525 6.34417 10.3308L8.4525 8.21292C8.72083 7.96375 8.7975 7.59 8.69208 7.25458C8.3375 6.18125 8.14583 5.03125 8.14583 3.83333C8.14583 3.30625 7.71458 2.875 7.1875 2.875H3.83333C3.30625 2.875 2.875 3.30625 2.875 3.83333C2.875 12.8321 10.1679 20.125 19.1667 20.125C19.6938 20.125 20.125 19.6938 20.125 19.1667V15.8125C20.125 15.2854 19.6938 14.8542 19.1667 14.8542Z"
        fill="#2B56A3"
      />
      <path
        d="M4.82031 4.79175H6.25781C6.3249 5.63508 6.46865 6.46883 6.68906 7.26425L5.53906 8.42383C5.15573 7.26425 4.90656 6.05675 4.82031 4.79175Z"
        fill="white"
      />
      <path
        d="M18.2081 18.1796C16.9431 18.0934 15.7164 17.8442 14.5664 17.4513L15.7164 16.3013C16.531 16.5313 17.3647 16.675 18.2081 16.7325V18.1796Z"
        fill="white"
      />
      <path
        d="M17.2497 5.75V2.875H15.333V5.75H12.458V7.66667H15.333V10.5417H17.2497V7.66667H20.1247V5.75H17.2497Z"
        fill="#CA367E"
      />
    </svg>
  );
}
